import { FormItem, SwitchInput } from '@framework/form';
import { Space } from 'antd';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { Widget } from '../../../../Widget';
import { TableCellWidgetList } from './TableCellWidgetList';

export interface IRowCustomFormSwitchProps {
  columns?: Widget[];
}

export function RowCustomFormSwitch(props: IRowCustomFormSwitchProps) {
  const { columns } = props;
  const customRow = useWatch({ name: 'customRow' });

  return (
    <>
      <FormItem name="customRow" label={null}>
        <Space align="center">
          <SwitchInput name="customRow" />
          <span>Riga Personalizzata</span>
        </Space>
      </FormItem>
      {customRow && <TableCellWidgetList name="cells" columns={columns} />}
    </>
  );
}
